import React,{useState} from 'react'
import { init, send ,sendForm } from 'emailjs-com';
import "./Help.css"

function Help() {
    const [name,setName] = useState<string>("");
    const [mail,setMail] = useState<string>("");
    const [message,setMessage] = useState<string>("");
    const onSubmit = async (e:any) => {
        e.preventDefault();
        const user_id:string = "yATiQPg8WhHxlhErp";
        const service_id :string= "service_qt0tz0n";
        const template_id :string= "template_4nvv4eq";
        if(user_id && service_id && template_id)
        {
            init(user_id );
            const template_param = {
                to_name: name,
                email: mail,
                message: message
            };
            try{
             await send(service_id,template_id,template_param);
             alert('送信に成功しました!!')
            } catch(error){
              alert("送信に失敗しました")
            }
            
        }
    }
    const onChangeName = (e:React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    }
    const onChangeMail = (e:React.ChangeEvent<HTMLInputElement>) => {
        setMail(e.target.value);
    }
    const onChangeMessage = (e:React.ChangeEvent<HTMLTextAreaElement>) => {
        setMessage(e.target.value);
    }

  return (
   <>
     <div className="contact-page">
      <p className="title">ご質問はこちら</p>
        <div className='item'>
          <label className='label'>お名前</label>
          <input type="text" className="inputs" name="name" onChange={onChangeName} required/>
        </div>
        <div className="item">
          <label className="label">メールアドレス</label>
          <input type="email" className="inputs" name="email" onChange={onChangeMail} />
        </div>
        <div className="item">
          <label className="label">ご質問</label>
          <textarea className="inputsf" placeholder="ご質問はこちら" onChange={onChangeMessage}></textarea>
        </div>
        <div className="button-area">
          <input type="submit" value="送信" onClick={onSubmit}/>
        </div>
     </div>
   </>
  )
}

export default Help